import React, { useEffect, useState } from "react";
import Repeatability_table from "./repeatability_table/Repeatability_table";
import Repeatability_Form from "./repeatability_Form/Repeatability_Form";

import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { GetAll } from "../../../../../../../features/admin/quality_management/process_requirement/repeatability/Slice";

function Repeatability({
  fetchCustomers,
  repeatabilitydetails,
  setCurrentPage,
  currentPage,
}) {
  const dispatch = useDispatch();
  const [showTable, setShowTable] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(FixIDS.repeatability.List);
  const haveAddPermission = permissions?.includes(
    FixIDS.repeatability.Add,
  ); //form

  const fetchData = () => {
    dispatch(GetAll({ page: currentPage }));
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  return (
    <>
      <div className="imperiality_Form_div">
        {haveAddPermission && (
          <Repeatability_Form
            fetchCustomers={fetchCustomers}
            selectionTypeId={1}
            onProceed={() => setShowTable(true)}
          />
        )}
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
        {haveReadPermission && (
          <Repeatability_table
            data={repeatabilitydetails}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            refreshData={fetchData}
          />
        )}
      </div>
      {/* )} */}
    </>
  );
}

export default Repeatability;
